<af-main-container [title]="(isEditMode ? 'i18n_af_subjectsEditSubject' : 'i18n_af_subjectsAddSubject') | translate :{subjectId: subjectId}"
                   [navigateBackListener]="navigateBack">
    @if (isLastStep) {
        <div CustomTitle
             fxFlex
             fxLayout="row" fxLayoutAlign="end center" class="w-100">
            <ui-kit-button [label]="'i18n_af_buttonCancel' | translate"
                           type="secondary"
                           [disabled]="Spinner.isShown('submit')"
                           (clickListener)="cancelToPotentialVictimsTab()"/>
            <ui-kit-button [label]="'i18n_af_buttonSave' | translate"
                           class="ml-16"
                           spinnerId="submit"
                           [disabled]="form.invalid || (contactDetailsForm.invalid && !canSaveWithoutContacts)"
                           (clickListener)="submit()"/>
        </div>
    }
    <div fxLayout="column" class="w-100 radius-16 bc-mono-white p-24 mt-24">
        @if (isPotentialVictim) {
            <ui-kit-stepper #stepper class="mb-24"
                            [currentStep]="currentStep"
                            [steps]="steps"
                            (stepIndexChangeListener)="currentStep = steps[$event]"/>
        }

        @if (currentStep === 'basicInfo') {
            <form [formGroup]="form"
                  (submit)="isPotentialVictim ? nextStep() : submit()"
                  fxLayout="column"
                  fxLayoutAlign="start start">
                <div class="grid-form-container">
                    @if (form.controls.subjectType) {
                        <af-dictionary-selector
                            dictionaryName="subject_type"
                            [control]="form.controls.subjectType"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="subjectResponse?.subjectType"
                            [disabled]="isEditMode || existingSubjectMode"
                            label="i18n_af_labelSubjectType"
                            placeholder="i18n_af_placeholderSubjectType"/>
                    }

                    @if (form.controls.subjectCategory) {
                        <af-dictionary-selector
                            [control]="form.controls.subjectCategory"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="isEditMode || isPotentialVictimOnlyUser ? 'POTENTIAL_VICTIM' : null"
                            [filterDictionaryBy]="isPotentialVictimOnlyUser ? ['POTENTIAL_VICTIM'] : null"
                            [excludeFromDictionary]="excludedCategories"
                            [disabled]="isEditMode || existingSubjectMode || isPotentialVictimOnlyUser"
                            dictionaryName="category"
                            class="w-100"
                            label="i18n_af_labelCategory"
                            placeholder="i18n_af_placeholderCategory"/>
                    }

                    @if (form.controls.country) {
                        <af-dictionary-selector
                            dictionaryName="country"
                            [control]="form.controls.country"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="subjectResponse?.country"
                            [disabled]="existingSubjectMode"
                            label="i18n_af_labelCountry"
                            placeholder="i18n_af_placeholderCountry"/>
                    }
                    @if (form.controls.surname) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelSurname' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.surname">
                                <input matInput
                                       formControlName="surname"
                                       [placeholder]="'i18n_af_placeholderSurname' | translate"
                                       name="surname"/>
                                @if (form.controls.surname.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.surname.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.name && form.controls.subjectType.value === SubjectType.PERSON) {
                        <div
                            fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelFirstName' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.name">
                                <input matInput
                                       formControlName="name"
                                       [placeholder]="'i18n_af_placeholderFirstName' | translate"
                                       name="name"/>
                                @if (form.controls.name.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.name.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.patronymic) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelPatronymic' | translate }}</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.patronymic">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderPatronymic' | translate"
                                       formControlName="patronymic"
                                       name="patronymic"/>
                                @if (form.controls.patronymic.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.patronymic.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (!!form.controls.originDate && form.controls.subjectType.value === SubjectType.PERSON) {
                        <af-date-picker-field
                            labelTranslationKey="i18n_af_labelDateOfBirth"
                            placeholderTranslationKey="i18n_af_placeholderDateOfBirth"
                            [minDate]="null"
                            [form]="form.controls.originDate"
                            [dateFormats]="DATE_FORMATS"
                            [supportedDateFormat]="['DDMMYYYY','DD.MM.YYYY']"/>
                    }

                    @if (form.controls.gender) {
                        <af-dictionary-selector
                            dictionaryName="gender"
                            [control]="form.controls.gender"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="subjectResponse?.gender"
                            [disabled]="existingSubjectMode"
                            label="i18n_af_labelGender"
                            placeholder="i18n_af_placeholderGender"/>
                    }
                    @if (form.controls.iin) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelIin' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.iin.valid">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderIin' | translate"
                                       formControlName="iin"
                                       name="iin"
                                       mask="000000000000"/>
                                @if (form.controls.iin.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.iin.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.iin.hasError('serverError')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ form.controls.iin.errors.serverError }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }
                    @if (form.controls.name && form.controls.subjectType.value === SubjectType.ORGANIZATION) {
                        <div
                            fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelTitle' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.name">
                                <input matInput
                                       formControlName="name"
                                       [placeholder]="'i18n_af_placeholderTitle' | translate"
                                       name="name"/>
                                @if (form.controls.name.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.name.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.type) {
                        <af-dictionary-selector
                            dictionaryName="org_type"
                            [control]="form.controls.type"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="subjectResponse?.type"
                            [disabled]="existingSubjectMode"
                            label="i18n_af_labelType"
                            placeholder="i18n_af_placeholderType"/>
                    }

                    @if (form.controls.originDate && form.controls.subjectType.value === SubjectType.ORGANIZATION) {
                        <af-date-picker-field
                            labelTranslationKey="i18n_af_labelRegistrationDate"
                            placeholderTranslationKey="i18n_af_placeholderRegisterDate"
                            [minDate]="null"
                            [form]="form.controls.originDate"
                            [dateFormats]="DATE_FORMATS"
                            [supportedDateFormat]="['DDMMYYYY','DD.MM.YYYY']"/>
                    }
                    @if (form.controls.bin) {
                        <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelBin' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.controls.bin.valid">
                                <input matInput
                                       [placeholder]="'i18n_af_placeholderBin' | translate"
                                       formControlName="bin"
                                       mask="000000000000"
                                       name="bin"/>
                                @if (form.controls.bin.hasError('required')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_fieldValidationRequired' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.bin.hasError('maxlength')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                                @if (form.controls.bin.hasError('serverError')) {
                                    <mat-error
                                        class="c-secondary-red-900">
                                        {{ form.controls.bin.errors.serverError }}
                                    </mat-error>
                                }
                            </mat-form-field>
                        </div>
                    }

                    @if (form.controls.phone) {
                        <af-phone-number
                            #phoneNumberComponent
                            [control]="form.controls.phone"
                            [predefinedValue]="form.controls.phone.value"
                            [disabled]="existingSubjectMode"
                            label="i18n_af_placeholderPhone"/>
                    }

                    @if (form.controls.requisiteType && !isPotentialVictim) {
                        <af-dictionary-selector
                            dictionaryName="requisite_type"
                            [control]="form.controls.requisiteType"
                            [resyncOnControlChange]="true"
                            [predefinedValue]="form.controls.requisiteType.value"
                            label="i18n_af_labelRequisiteType"
                            placeholder="i18n_af_placeholderRequisiteType"/>
                    }

                    @if (form.controls.requisiteType?.value === 'ELECTRONIC_WALLET') {
                        @if (form.controls.walletNumber) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                                <div class="t5 c-primary-gray-600">
                                    {{ 'i18n_af_labelWalletNumber' | translate }}
                                    {{ form.controls.walletNumber.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.walletNumber && form.controls.walletNumber.valid">
                                    <input matInput
                                           formControlName="walletNumber"
                                           (input)="onWalletNumberInput($event)"
                                           [placeholder]="'i18n_af_placeholderWalletNumber' | translate"
                                           name="walletNumber"/>
                                    @if (form.controls.walletNumber.hasError('minlength')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthWallet' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.walletNumber.hasError('maxlength')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthWallet' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.walletNumber.hasError('pattern')) {
                                        <mat-error class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationWalletPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }

                    @if (form.controls.requisiteType?.value === 'PAYMENT_POINT') {
                        @if (form.controls.paymentPointNumber) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                                <div class="t5 c-primary-gray-600">
                                    {{ 'i18n_af_labelPaymentPointNumber' | translate }}
                                    {{ form.controls.paymentPointNumber.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.paymentPointNumber">
                                    <input matInput
                                           formControlName="paymentPointNumber"
                                           maxlength="34"
                                           (input)="paymentPointNumberInput($event)"
                                           [placeholder]="'i18n_af_placeholderPaymentPointNumber' | translate"/>
                                    @if (form.controls.paymentPointNumber.hasError('required')) {
                                        <mat-error>
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.paymentPointNumber.hasError('maxlength')) {
                                        <mat-error>
                                            {{ 'i18n_af_terminalMaxLength' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.paymentPointNumber.hasError('pattern')) {
                                        <mat-error>
                                            {{ 'i18n_af_terminalInvalidFormat' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }
                    @if (form.controls.requisiteType?.value === 'ACCOUNT_KZ') {
                        @if (form.controls.ibanKz) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.ibanKz.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.ibanKz && form.controls.ibanKz.valid">
                                    <input matInput
                                           formControlName="ibanKz"
                                           [maxlength]="KZ_IBAN_LENGTH"
                                           (input)="onIbanInput($event, 'ibanKz')"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="ibanKz"/>
                                    @if (form.controls.ibanKz.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanKz.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanKz.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthIbanKz' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanKz.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }
                    @if (form.controls.requisiteType?.value === 'ACCOUNT_FOREIGN_BANK') {
                        @if (form.controls.ibanForeign) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelIban' | translate }} {{ form.controls.ibanForeign.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.ibanForeign && form.controls.ibanForeign.valid">
                                    <input matInput
                                           formControlName="ibanForeign"
                                           [maxlength]="IBAN_MAX_LENGTH"
                                           (input)="onIbanInput($event, 'ibanForeign')"
                                           [placeholder]="'i18n_af_placeholderIban' | translate"
                                           name="ibanForeign"/>
                                    @if (form.controls.ibanForeign.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanForeign.hasError('minlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMinLengthForeignIban' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanForeign.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationMaxLengthError' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.ibanForeign.hasError('pattern')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationIbanPattern' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }
                    @if (form.controls.requisiteType?.value === 'CARD_MASK') {
                        @if (form.controls.cardMaskNumber) {
                            <div fxLayout="column" fxLayoutAlign="start start" class="w-476">
                                <div
                                    class="t5 c-primary-gray-600">{{ 'i18n_af_labelCardMask' | translate }} {{ form.controls.cardMaskNumber.hasValidator(Validators.required) ? '*' : '' }}
                                </div>
                                <mat-form-field class="w-100 mt-4"
                                                [class.value-not-empty]="form.value.cardMaskNumber && form.controls.cardMaskNumber.valid">
                                    <input matInput
                                           formControlName="cardMaskNumber"
                                           [dropSpecialCharacters]="false"
                                           [showMaskTyped]="true"
                                           [specialCharacters]="['#']"
                                           mask="000000######0000"
                                           name="cardMaskNumber"/>
                                    @if (form.controls.cardMaskNumber.hasError('required')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationRequired' | translate }}
                                        </mat-error>
                                    }
                                    @if (form.controls.cardMaskNumber.hasError('maxlength')) {
                                        <mat-error
                                            class="c-secondary-red-900">
                                            {{ 'i18n_af_fieldValidationCardMaxLengthError' | translate }}
                                        </mat-error>
                                    }
                                </mat-form-field>
                            </div>
                        }
                    }
                </div>
                @if (form.controls.creationReason && isPotentialVictim) {
                    <div class="t2-semi-bold mt-40">{{ 'i18n_af_labelCreationReasonSection' | translate }}</div>
                    <div class="grid-form-container mt-16">
                        <af-dictionary-selector
                            dictionaryName="subject_creation_reason"
                            [control]="form.controls.creationReason"
                            [resyncOnControlChange]="true"
                            [disabled]="form.controls.creationReason.disabled"
                            [predefinedValue]="subjectResponse ? potentialVictimCategory?.creationReason : null"
                            label="i18n_af_labelCreationReason"
                            placeholder="i18n_af_placeholderCreationReason"/>
                        <div class="grid-col-span-2">
                            <div class="t5 c-primary-gray-600">{{ 'i18n_af_labelSubjectDescription' | translate }} *</div>
                            <mat-form-field class="w-100 mt-4"
                                            [class.value-not-empty]="form.value.description">
                                <textarea matInput
                                          formControlName="description"
                                          class="resize-none pt-12 pb-12"
                                          [placeholder]="'i18n_af_placeholderSubjectDescription' | translate"
                                          rows="8"
                                          maxlength="2000"></textarea>
                                @if (form.controls.description.hasError('maxlength')) {
                                    <mat-error class="c-secondary-red-900">
                                        {{ 'i18n_af_maxlengthError' | translate }}
                                    </mat-error>
                                }
                                <mat-hint align="end">{{ form.value.description?.length || 0 }} / 2000</mat-hint>
                            </mat-form-field>
                        </div>
                    </div>
                }
                @if (!!form.controls.subjectType.value) {
                    <div fxLayout="row" fxLayoutAlign="start center" class="mt-40">
                        <ui-kit-button spinnerId="nextStep"
                                       [disabled]="form.invalid || (isEditMode && !isPotentialVictim && !isFormChanged)"
                                       [label]="(isPotentialVictim ? 'i18n_af_buttonNext' : 'i18n_af_buttonSave') | translate"/>
                        <ui-kit-button class="ml-16"
                                       color="accent"
                                       buttonType="button"
                                       type="text"
                                       (clickListener)="cancelToPotentialVictimsTab()"
                                       [label]="'i18n_af_buttonCancel' | translate"/>
                    </div>
                }
            </form>
        }

        @if (currentStep === 'subjectContactDetails' && isPotentialVictim) {
            <af-contact-details-step
                [form]="contactDetailsForm"
                [contactDetailsResponses]="(editMode === 'CONTACT_ONLY' && !isNpckAdmin) ? [] : existingContactDetails"
                [hideDefaultButtons]="true"
                [canDelete]="isNpckAdmin"
                [contactTypeOptional]="true"
                [phoneDisabled]="isEditMode"/>
        }
    </div>
</af-main-container>
